export function arrayToString(array: Uint8Array): string {
  const uint16array = new Uint16Array(array.buffer);
  return String.fromCharCode.apply(null, Array.from(uint16array));
}
